import { render } from "./settings.vue.js?vue&type=template&id=ed46de82!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./settings.vue?vue&type=template&id=ed46de82"
import script from "./settings.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__